<template>
  <div>
    <div class="my-3 row justify-content-between" v-for="listItem in items" :key="listItem.id">
      <!-- START : Buy it again product Checkbox -->
      <div
        class="col-1 d-flex align-items-center justify-content-flex-start justify-content-lg-center"
      >
        <WCCheckbox :value="listItem" v-model="checkedListItems" :ariaLabel="listItem.item.name" />
      </div>
      <!-- END : Buy it again product Checkbox -->

      <!-- START : Buy it again product image and details -->
      <WCProductDetailsImage :item="listItem.item" class="col-3 col-md-2 pl-3 pl-lg-4" />

      <WCListProductDetails
        :listItem="listItem"
        :hasRemove="false"
        :listViewScanMode="isCustomerModeScan"
        :showQuantity="showQuantity"
      />
      <!-- START : Buy it again product image and details -->
    </div>
  </div>
</template>

<script>
import WCCheckbox from '@/modules/forms/components/WCCheckbox/WCCheckbox.vue';
import WCProductDetailsImage from '@/modules/lists/components/WCProductDetailsImage/WCProductDetailsImage.vue';
import WCListProductDetails from '@/modules/lists/components/WCListProductDetails/WCListProductDetails.vue';

export default {
  name: 'WCBuyItAgainItems',
  props: {
    items: {
      type: Array,
      required: true,
    },
    checkedItems: {
      type: Array,
      required: true,
    },
    isCustomerModeScan: {
      type: Boolean,
      default: false,
    },
    showQuantity: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['checkedListchange'],
  components: {
    WCCheckbox,
    WCProductDetailsImage,
    WCListProductDetails,
  },
  computed: {
    /**
     * Property to get and set checkitems and emit to parent
     */
    checkedListItems: {
      get() {
        return this.checkedItems;
      },
      set(value) {
        this.$emit('checkedListchange', value);
      },
    },
  },
};
</script>
